import { render, staticRenderFns } from "./CardTab.vue?vue&type=template&id=fc6679f4&"
import script from "./CardTab.vue?vue&type=script&lang=js&"
export * from "./CardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc6679f4')) {
      api.createRecord('fc6679f4', component.options)
    } else {
      api.reload('fc6679f4', component.options)
    }
    module.hot.accept("./CardTab.vue?vue&type=template&id=fc6679f4&", function () {
      api.rerender('fc6679f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/card-tab/CardTab.vue"
export default component.exports